export class LoginModel {
   username: string;
   password: string;
   constructor() { 
   }
} 


// WEBPACK FOOTER //
// ./src/app/models/login.model.ts